import React, { Component, useState, useCallback } from 'react'
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import axios from 'axios';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ENDPOINTS } from '@/config/endpoints';
import { useRouter } from 'next/router';

const schema = yup.object({
    Name: yup.string().required("This field is required."),
    Email: yup.string().required("This field is required.").email("Email is not valid"),
 
  });


const CaseStudyForm=(props)=> {
  const router = useRouter();
  const [ThankyouRes, setThankyouRes] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [errMSG,setErrMSG]= useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { register, handleSubmit,setValue, formState: { isDirty, isValid,errors } } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema)
  });
  const handleCaptchaSubmit = useCallback((values) => {
    
      if (!executeRecaptcha) {
        return false;
      }
      executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
        onFormSubmit(values,gReCaptchaToken);
      });
    },
    [executeRecaptcha]
  );
  // handle form submit
  async function onFormSubmit(values,gReCaptchaToken) {
    
    const body = {
      "formType": props.formCSType,
      "name": values.Name,
      "email": values.Email,
      "phoneNumber": values.Phone,
      "company": values.Companyname,
      "businessType":values.businesstype,
      "turnover":values.turnover,
      "designation":values.occupation,
      "sourceUrl": window.location.href
    }  
    // console.log('body',body)

    // return false;
    let config = {
      method: 'post',
      url: ENDPOINTS.CONTACT_US_V1,
      headers: {
        'Content-Type': 'application/json',
        'g-recaptcha-response':gReCaptchaToken
      },
      data: body,
    };

    try {
      const response = await axios(config);
      if (response.status == 200) {
        // console.log('ok')
        setSubmitDisabled(true);
        setThankyouRes(true) ;
        
        setTimeout(() => {
          setThankyouRes(false);
          // window.location.reload();
          router.push('/thankyou-response')
        }, 3000);
      

      }
    } catch (err) {
      setErrMSG(true);
      console.log('error',err)
      setTimeout(() => {
      }, 5000);
     }
    
  }

  const handleConversion = () => {
    const conversionId = 'AW-11325447679/uX8RCPrflOAYEP-7spgq';

    // Send the conversion event to Google Analytics using gtag.
    window.gtag('event', 'conversion', {
      'send_to': conversionId,
    });
  }
  
    return (
      
      <div className='w-full' >
        <h4 className='text-base2 text-secondary font-regular'>Download our case study</h4>
        <p className='text-sm text-secondary font-regular'>Please fill the details below:</p>
        <form action="#" method="POST" onSubmit={handleSubmit(handleCaptchaSubmit)}>
          <div className='flex justify-between flex-wrap'>
            <div className="mt-1 w-[48%]">
              <input
              type="text"
              name="name"
              id="name"
              className="block w-full h-[43px] px-2 text-sm rounded-md border border-[#aaa] sm:text-sm focus:border-[#555] focus:ring-[#555] focus:outline-none"
              placeholder="Name*" {...register("Name")}
              />
              <p className='text-progressColor4 text-xs'>{errors.Name?.message}</p>
            </div>
            <div className="mt-1 w-[48%]">
                  <input
                  type="email"
                  name='email'
                  id="email"
                  className="block w-full h-[43px] px-2 text-sm rounded-md border border-[#aaa] sm:text-sm focus:border-[#555] focus:ring-[#555] focus:outline-none"
                  placeholder="Email Id*" {...register("Email")}
                  />
                  <p className='text-progressColor4 text-xs'>{errors.Email?.message}</p>
              </div>
              <div className="mt-1 w-[48%]">
                <input
                type="tel"
                id="phone"
                name="phone"
                className="block w-full h-[43px] px-2 text-sm rounded-md border border-[#aaa] sm:text-sm focus:border-[#555] focus:ring-[#555] focus:outline-none"
                placeholder="Phone Number" {...register("Phone")}
                />
                <p className='text-progressColor4 text-xs'>{errors.Phone?.message}</p>
              </div>
              <div className="mt-1 w-[48%]">
              <input
                type="text"
                id="company"
                name="company"
                className="block w-full h-[43px] px-2 text-sm rounded-md border border-[#aaa] sm:text-sm focus:border-[#555] focus:ring-[#555] focus:outline-none"
                placeholder="Company" {...register("Companyname")}
                />
                <p className='text-progressColor4 text-xs'>{errors.Companyname?.message}</p>
              </div>
              <div className="mt-1 w-[48%]">
                <div className="relative  bg-white">
                  <select
                  {...register("businesstype")}
                    onChange={(e) => setValue('businesstype', e.target.value, { shouldValidate: true })} // Using setValue
                    className="appearance-none block w-full h-[43px] px-2 text-sm ring-0 focus:ring-0 shadow-none rounded-md border-[#aaa] border-[1px] sm:text-sm focus:outline-none" 
                    required id="businesstype" name='businesstype'>
                      <option value="" defaultValue>Nature of Business</option>
                    <option value="export">Export</option>
                    <option value="domestic">Domestic</option>
                    <option value="both">Both</option>
                  </select>
                  <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center px-2 text-gray-400 border-l border-bordercolor ">
                      <svg className="h-4 w-4" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20">
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                  </div>
                </div>
              <p className='text-progressColor4 text-xs'>{errors.Companyname?.message}</p>
              </div>
              <div className="mt-1 w-[48%]">
                  <div className="relative bg-white">
                    <select className="appearance-none block w-full h-[43px] px-2 text-sm ring-0 focus:ring-0 shadow-none rounded-md border-[#aaa] border-[1px] sm:text-sm focus:outline-none"  id="turnover"
                    {...register("turnover")} required name='turnover'
                    onChange={(e) => setValue('turnover', e.target.value, { shouldValidate: true })}
                    >
                      <option value="" defaultValue>Turnover</option>
                      <option value="3 - 10 Cr">3-10 Cr</option>
                      <option value="10-50-cr">10-50 Cr</option>
                      <option value="more-than-50-cr">More than 50 Cr</option>
                    </select>
                    <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center px-2 text-gray-400 border-l border-bordercolor ">
                        <svg className="h-4 w-4" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                        </svg>
                    </div>
                </div>
              <p className='text-progressColor4 text-xs'>{errors.turnover?.message}</p>
              </div>
              <div className="mt-1 w-[48%]">
                    <div className="relative bg-white">
                      <select className='appearance-none block w-full h-[43px] px-2 text-sm ring-0 focus:ring-0 shadow-none rounded-md border-[#aaa] border-[1px] sm:text-sm focus:outline-none' id="occupation"
                      {...register("occupation")} required name='occupation'
                      onChange={(e) => setValue('occupation', e.target.value, { shouldValidate: true })}
                      >
                        <option value="" defaultValue>Occupation</option>
                        <option value="business-owner">Business owner</option>
                        <option value="self-employed">Self employed</option>
                        <option value="salaried">Salaried</option>
                        <option value="student">Student</option>
                        <option value="none">None of the above</option>
                      </select>
                      <div className="pointer-events-none absolute right-0 top-0 bottom-0 flex items-center px-2 text-gray-400 border-l border-bordercolor ">
                          <svg className="h-4 w-4" xmlns="https://www.w3.org/2000/svg" viewBox="0 0 20 20">
                              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                          </svg>
                      </div>
                  </div>
              <p className='text-progressColor4 text-xs'>{errors.occupation?.message}</p>
              </div>
            </div>
        
       
        <button name="submitButton" onClick={handleConversion} type='submit' disabled={!isDirty || !isValid} className='bg-brand h-[40px] mx-auto block text-center text-white text-sm w-[235px] disabled:opacity-50 rounded-[4px] mt-5'>Submit</button>
        {/* {ThankyouRes ? <ThankyouResponse /> : null} */}
        {errMSG ? <>
          <div className='text-[red] text-center' >
            <p className='text-sm font-medium mt-3'>
              There is some server response error.
              {/* We have sent you the success story on the provided email id. */}
              </p>
         </div>
        </> : null}
        {ThankyouRes ? 
        <>
         <div className='text-green text-center' >
            <p className='text-sm font-medium mt-3'>
              Successfull Submission : Thank you for your interest. 
              {/* We have sent you the success story on the provided email id. */}
              </p>
         </div>
        </>
        : null}
      </form>
      </div>
    )
}

export default CaseStudyForm;
